export default __webpack_public_path__ + "static/media/LVFS.82e029f6.svg";